import { render, staticRenderFns } from "./UnifiedCallback.vue?vue&type=template&id=27222bc6&scoped=true"
import script from "./UnifiedCallback.vue?vue&type=script&lang=js"
export * from "./UnifiedCallback.vue?vue&type=script&lang=js"
import style0 from "./UnifiedCallback.vue?vue&type=style&index=0&id=27222bc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27222bc6",
  null
  
)

export default component.exports